import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Col } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../redux/services/apiPath";
import * as Yup from "yup";
import authHeader from "../../../redux/services/authHeader";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name Is Required"),
  price: Yup.number().required("Number Is Required").positive(),
});

const CreateAddons = (props) => {
  const [initialValues, setInitialValues] = useState({
    name: "",
    price: "",
    isActive: true,
  });
  useEffect(() => {
    setInitialValues({
      name: props?.data?.name || "",
      price: props?.data?.price || "",
      isActive: props?.data?.isActive || true,
      addonId: props?.data?._id || "",
    });
  }, [props?.data]);
  const handleSubmit = async (values) => {
    const data = {
      vendorId: localStorage.getItem("vendorId")
        ? localStorage.getItem("vendorId")
        : "",
      ...values,
    };
    let url = ``;
    if (values?.addonId) {
      url = `${BASE_URL}addon/updateAddOn`;
    } else {
      url = `${BASE_URL}addon/createAddOn`;
      delete data?.addonId;
    }
    const res = await axios.post(url, data, authHeader());

    if (res?.data?.status == "success") {
      toast.success(res?.data?.message);

      props.onHide();
    } else {
      toast.error("Something Went Wrong ");
    }
  };
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Create Addon
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="ms-panel ms-panel-fh">
                <div className="ms-panel-body">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {(formik) => (
                      <Form className="needs-validation clearfix" noValidate>
                        <div className="form-row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="name">
                              Name<span className="error">*</span>
                            </label>
                            <Field
                              type="text"
                              className={`form-control ${
                                formik.errors.name && formik.touched.name
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={formik?.values?.name}
                              id="name"
                              name="name"
                              placeholder="Addon Name"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="price">
                              Price<span className="error">*</span>
                            </label>
                            <Field
                              type="number"
                              className={`form-control ${
                                formik.errors.price && formik.touched.price
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={formik?.values?.price}
                              id="price"
                              name="price"
                              placeholder="price"
                            />
                            <ErrorMessage
                              name="price"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-12 mb-3">
                            <label htmlFor="isActive">
                              Is Active<span className="error">*</span>
                            </label>
                            <select
                              name="isActive"
                              value={formik?.values?.isActive}
                              className={`form-control ${
                                formik.errors.price && formik.touched.price
                                  ? "is-invalid"
                                  : ""
                              }`}
                            >
                              <option value="">Select Option</option>
                              <option value={true}>Active</option>
                              <option value={false}>Inactive</option>
                            </select>
                            <ErrorMessage
                              name="price"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>

                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateAddons;
